<vue-panel
    [title]="'label.password' | translate: 'PortalBase' | async"
    [action1Label]="'button.Edit' | translate: 'PortalBase' | async"
    (action1ButtonClicked)="editPassword()"
    *ngIf="passwordView">
    <p>{{ passwordViewDefaultMessage }}</p>
    <span></span>
</vue-panel>
<vue-panel [title]="'label.editPasswordLabel' | translate: 'PortalBase' | async"
            *ngIf="passwordEdit">
    <vue-password-strength-input
      #passwordComponent
      [formError]="formError"
      [validationRequiredRules]="requiredRules"
      [hasOldPassword]="true"
      inputWidthClass="wider"
      [oldPasswordLabel]="'passwordTab.currentPasswordLabel' | translate: 'PortalBase' | async"
      [newPasswordLabel]="'passwordTab.newPassword' | translate: 'PortalBase' | async"
      [confirmPasswordLabel]="'passwordTab.reEnterNewPassword' | translate: 'PortalBase' | async">
    </vue-password-strength-input>
    <vue-form-buttons
          [secondaryLabel]="'label.cancel' | translate: 'PortalBase' | async"
          (secondaryButtonClicked)="changeToViewMode()"
          [primaryLabel]="'label.save' | translate: 'PortalBase' | async"
          (primaryButtonClicked)="save()">
    </vue-form-buttons>
</vue-panel>